import { Col, Row } from "reactstrap";
import { H6, P } from "../../../../AbstractElements";
import { DescriptionListTitle } from "../../../../Constants/Constants";

const DescriptionList = () => {
  return (
    <Col md="12" xxl="6">
      <div className="card-wrapper border rounded-3 bg-success-light h-100">
        <H6 className="sub-title fw-bold">{DescriptionListTitle}</H6>
        <dl>
          <Row>
            <Col sm="3"><dt className="text-truncate">Description lists</dt></Col>
            <Col sm="9"><dd>A description list is perfect for defining terms.</dd></Col>
            <Col sm="3"><dt>Term</dt></Col>
            <Col sm="9">
              <dd>
                <P>Definition for the term.</P>
                <P>And some more placeholder definition text.</P>
              </dd>
            </Col>
            <Col sm="3"><dt>Another term</dt></Col>
            <Col sm="9"><dd>This definition is short, so no extra paragraphs or anything.</dd></Col>
            <Col sm="3"><dt className="text-truncate">Truncated term is truncated</dt></Col>
            <Col sm="9"><dd>This can be useful when space is tight. Adds an ellipsis at the end.</dd></Col>
            <Col sm="3"><dt>Nesting</dt></Col>
            <Col sm="9">
              <dd>
                <dl>
                  <Row>
                    <Col sm="4"><dt>Nested definition list</dt></Col>
                    <Col sm="8"><dd>I heard you like definition lists. Let me put a definition list inside your definition list.</dd></Col>
                  </Row>
                </dl>
              </dd>
            </Col>
          </Row>
        </dl>
      </div>
    </Col>
  );
};
export default DescriptionList;
